import { render } from "./newHotelBook.vue?vue&type=template&id=acbcaa70"
import script from "./newHotelBook.vue?vue&type=script&lang=js"
export * from "./newHotelBook.vue?vue&type=script&lang=js"

import "./newHotelBook.vue?vue&type=style&index=0&id=acbcaa70&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__